import React, { Component } from "react";

import BackWithSearch from "../../Elements/BackWithSearch";
import ContentLoader from "react-content-loader";
import { Link } from "react-router-dom";
import { brandRoute } from "../../../../helpers/restaurantSlugDetector";
import { connect } from "react-redux";
import StoreCoupons from "./StoreCoupons"
import { setFavoriteRest } from "../../../../services/items/actions";

class RestaurantInfo extends Component {
	state = {
		withLinkToRestaurant: false,
		isFavorite: false,
	};

	componentDidMount() {
		this.setState({ withLinkToRestaurant: this.props.withLinkToRestaurant });

		if (this.props.history && this.props.history.location && this.props.history.location.state && this.props.history.location.state.fromExplorePage) {
			this.setState({ withLinkToRestaurant: this.props.history.location.state.fromExplorePage });
		}

		this.registerScrollEvent();
	}

	componentWillUnmount() {
		this.removeScrollEvent();
	}

	fixedRestaurantInfo = (hidden) => {
		if (this.child) {
			if (hidden) {
				this.child.heading.classList.add("hidden");
			} else {
				this.child.heading.classList.remove("hidden");
			}
		}
	};

	registerScrollEvent() {
		window.addEventListener("scroll", this.scrollFunc);
	}
	removeScrollEvent() {
		window.removeEventListener("scroll", this.scrollFunc);
	}
	scrollFunc = () => {
		if (document.documentElement.scrollTop > 55) {
			let hidden = false;
			this.fixedRestaurantInfo(hidden);
		}
		if (document.documentElement.scrollTop < 55) {
			let hidden = true;
			this.fixedRestaurantInfo(hidden);
		}
	};

	setFavoriteRestaurant = () => {
		const { restaurant_info, user } = this.props;
		if (user.success) {
			if (restaurant_info.is_favorited) {
				this.refs.heartIcon.classList.remove("is-active");
			} else {
				this.refs.heartIcon.classList.add("is-active");
			}
			this.props.setFavoriteRest(user.data.auth_token, restaurant_info.id);
		}
	};

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.restaurant_info !== prevState.restaurant_info) {
			return {
				data: nextProps.restaurant_info,
			};
		} else {
			return null;
		}
	}

	render() {
		const { history, restaurant, user } = this.props;
		return (
			<React.Fragment>
				<div className="bg-white">
					<BackWithSearch
						ref={(node) => {
							this.child = node;
						}}
						history={history}
						boxshadow={false}
						has_restaurant_info={true}
						restaurant={restaurant}
						disable_search={true}
						homeButton={true}
						shareButton={true}
					/>
					{restaurant.length === 0 ? (
						<div style={{ paddingTop:"35px" }}>
						<ContentLoader
							className="custom-gradle-bg"
							height={170}
							width={400}
							speed={1.2}
							primaryColor="#f3f3f3"
							secondaryColor="#ecebeb"
						>
							<rect x="20" y="70" rx="4" ry="4" width="80" height="78" />
							<rect x="144" y="85" rx="0" ry="0" width="115" height="18" />
							<rect x="144" y="115" rx="0" ry="0" width="165" height="16" />
						</ContentLoader>
						</div>
					) : (
						<React.Fragment>
							<Link
								to={"../../stores/" + restaurant.slug}
								className={`store-info-itemspage ${this.state.withLinkToRestaurant ? "" : "no-click"}`}
							>
								<div style={{ paddingTop:"51px" }}>
									<div className="custom-gradle-bg">
										<div className="row">
											<div className={`${restaurant.is_appview === 0 ? "col-8" : "col-10"}`}>
												<div className="ml-5 px-15 mt-5 w-100">
													<h4 className="res-info-name mb-5 text-dark break-word">{restaurant.name}</h4>
													<div className="font-size-sm truncate-text res-info-desc">
														{restaurant.description}
													</div>
													<div className="font-size-sm truncate-text res-info-desc">
														{restaurant.landmark} {restaurant.distance && (",")} {restaurant.distance && restaurant.distance.toFixed(1) (" Kms")}
													</div>
													{restaurant.is_pureveg === 1 && (
														<p className="mb-0">
															<span className="font-size-sm pr-1 res-info-desc">
																{localStorage.getItem("pureVegText")}
															</span>
															<img
																src="/assets/img/various/pure-veg.png"
																alt="PureVeg"
																style={{ width: "20px" }}
															/>
														</p>
													)}
												</div>
											</div>
											{restaurant.is_appview === 0 ? (
											<div className="col-4">
												<div className="mt-5 pb-15 mr-15">
													<button className="RestaurantRatings_wrapper__2294i">
														<span className="RestaurantRatings_avgRating__1TOWY">
															<span className="icon-star"></span><span className="ml-1">{restaurant.avgRating === "0" ? (
															<React.Fragment>
																{restaurant.rating}
															</React.Fragment>
														) : (
															<Link to={brandRoute("/reviews/" + restaurant.slug)} style={{ display: "contents" }} className="yes-click">
															{restaurant.avgRating}
															</Link>
														)}</span>
														</span>
														<span className="RestaurantRatings_totalRatings__3d6Zc">100+ ratings</span>
													</button>
												</div>
											</div>
											):(
												<div className="col-2">
													{user.success && (
														<span className="favStore" onClick={this.setFavoriteRestaurant}>
															<div
																ref="heartIcon"
																className={`heart ${restaurant.is_favorited && "is-active"}`}
															/>
														</span>
													)}
												</div>
											)}
										</div>
										<hr className="mr-15 ml-15 res-ino-division-hr" />
										{restaurant.is_appview === 0 ? (
										<div className="col-12 res-info-time-wrap" style={{ display: 'flex', alignItems: 'center' }}>
											<div className="float-left col-4 p-0 store-distance-block">
												<i className="si si-clock" /> {restaurant.delivery_time}{" "}
												{localStorage.getItem("homePageMinsText")}
											</div>
											<div className="d-flex col-6 p-0 store-avgprice-block text-lowercase">
												<i className="si si-wallet mr-2" />{" "}
												{localStorage.getItem("currencySymbolAlign") === "left" && (
													<React.Fragment>
														{localStorage.getItem("currencyFormat")}
														{restaurant.price_range}{" "}
													</React.Fragment>
												)}
												{localStorage.getItem("currencySymbolAlign") === "right" && (
													<React.Fragment>
														{restaurant.price_range}
														{localStorage.getItem("currencyFormat")}{" "}
													</React.Fragment>
												)}
												{localStorage.getItem("homePageForTwoText")}
											</div>
											{restaurant.distance !== undefined && restaurant.distance !== null && restaurant.distance (
											<div className="d-flex col-6 p-0 store-distance-block text-lowercase">
												<i className="si si-pointer mr-2" />{" "}
												{restaurant.distance && restaurant.distance.toFixed(1)}{" "}Km
											</div>
											)}
											<div className="col">
												{user.success && (
													<span className="favStore" onClick={this.setFavoriteRestaurant}>
														<div
															ref="heartIcon"
															className={`new heart ${restaurant.is_favorited && "is-active"}`}
														/>
													</span>
												)}
											</div>
										</div>
										):(
										<div className="container">
											<div className="row">
												<div className="col-4 text-center">
												<span className="icon-star"></span><span className="ml-1 new-time-wrap">{restaurant.avgRating === "0" ? (
													<React.Fragment>
														{restaurant.rating}
													</React.Fragment>
												) : (
													<React.Fragment>
													<Link to={brandRoute("/reviews/" + restaurant.slug)} style={{ display: "contents" }} className="yes-click new-time-wrap"> {restaurant.avgRating}
													</Link>
													</React.Fragment>
												)}</span>
												<p className="mb-1 res-info-new-wraper">100+ ratings</p>
												</div>
												<div className="col-4 text-center">
												<span className="new-time-wrap">{restaurant.delivery_time}{" "}{localStorage.getItem("homePageMinsText")}</span>
												<p className="mb-1 res-info-new-wraper">Delivery Time</p>
												</div>
												<div className="col-4 text-center">
												<span>{localStorage.getItem("currencySymbolAlign") === "left" && (
														<React.Fragment>
															<span className="new-time-wrap">
															{localStorage.getItem("currencyFormat")}
															{restaurant.price_range}{" "}
															</span>
														</React.Fragment>
													)}
													{localStorage.getItem("currencySymbolAlign") === "right" && (
														<React.Fragment>
															<span className="new-time-wrap">
															{restaurant.price_range}
															{localStorage.getItem("currencyFormat")}{" "}
															</span>
														</React.Fragment>
													)}
												</span>
												<p className="mb-1 res-info-new-wraper">{localStorage.getItem("homePageForTwoText")}</p>
												</div>
											</div>
										</div>
										)}
										<hr className="mr-15 ml-15 res-ino-division-hr" />
									</div>
								</div>
							</Link>
							{/* {user.success && (
								<span onClick={this.setFavoriteRestaurant}>
									<div
										ref="heartIcon"
										className={`heart ${restaurant.is_favorited && "is-active"}`}
									/>
								</span>
							)} */}
						</React.Fragment>
					)}
				</div>
				<StoreCoupons coupons={restaurant.coupons}/>
				{restaurant.custom_message !== "<p><br></p>" &&
					restaurant.custom_message !== "null" &&
					(restaurant.custom_message !== "" && (
						<div
							style={{
								position: "relative",
								background: "#fff",
							}}
							dangerouslySetInnerHTML={{
								__html: restaurant.custom_message,
							}}
						/>
					))}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state) => ({
	restaurant_info: state.items.restaurant_info,
	user: state.user.user,
});

export default connect(
	mapStateToProps,
	{ setFavoriteRest }
)(RestaurantInfo);
